// eslint-disable
<template>
  <div
    style="
      width: 100vw;
      height: 100vh;
      display: flex;
      justify-content: center;
      align-items: center;
    "
  >
    <h1>This is a Contact page</h1>
  </div>
</template>

<script>
export default {
  name: "ContactView",
};
</script>
